import { queryKeys } from '@/lib/query-keys';
import { apiClient } from '@borradh-workspace/api-client';
import type { QueryConfig } from '@borradh-workspace/api-client/react-query';
import { queryOptions, useQuery } from '@tanstack/react-query';
import type { ListMetaAdsPagesResponse } from '../../types';

type PageListPurpose = 'posting';

export const listMetaAdsPagesQueryOptions = (purpose?: PageListPurpose) => {
  return queryOptions({
    queryKey: queryKeys.integrations.metaAdsPages(purpose),
    queryFn: () =>
      apiClient.get<ListMetaAdsPagesResponse>(
        purpose
          ? `integrations/meta-ads/pages?purpose=${purpose}`
          : 'integrations/meta-ads/pages'
      ),
    staleTime: 60 * 1000, // 1 minute
  });
};

type UseListMetaAdsPagesOptions = {
  purpose?: PageListPurpose;
  queryConfig?: QueryConfig<typeof listMetaAdsPagesQueryOptions>;
};

export const useListMetaAdsPages = ({
  purpose,
  queryConfig,
}: UseListMetaAdsPagesOptions = {}) => {
  const query = useQuery({
    ...listMetaAdsPagesQueryOptions(purpose),
    ...queryConfig,
  });

  return {
    pages: query.data?.pages ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
};
